import React from "react";
import PropTypes from "prop-types";
import {withStyles} from "@material-ui/core/styles";
import Modal from '@material-ui/core/Modal';
import Grow from '@material-ui/core/Grow';
import modalStyle from '../style'
import {getTranslation} from "../../../helpers/get-translation";
import Button from "@material-ui/core/Button";

const wheelImage = getTranslation("image_wheel_starting_position");
const wheelOffImage = getTranslation("image_wheel_off");
const pointerOnImage = getTranslation("image_wheel_pointer_on");
const pointerOffImage = getTranslation("image_wheel_pointer_off");
const bulbImage = getTranslation("image_wheel_winner_bulb");

const styles = theme => (Object.assign({}, modalStyle, {
	modalBody: {
		backgroundColor: theme.palette.background.paper,
		boxShadow: theme.shadows[5],
		maxHeight: "80%",
		padding: "32px 85px",
	},
	header: {
		fontSize: "30px",
		fontWeight: "500",
		color:" #0087FF"
	},
	pointerImage: {
		zIndex: 10,
		position: "absolute",
		left: "0",
		right: "0",
		margin: "auto",
		marginBottom: "0px",
		width: "25px",
		paddingTop: "5px",
	},
	wheelContainer: {
		position: "relative",
		margin: "20px 0",
		"& > img": {
			width: "100%",
		}
	},
	wheelOffImage: {
		position: "absolute",
		bottom: 0,
		top: 0,
		left: 0,
		right: 0,
		zIndex: 5,

		"-webkit-animation":"$spin 20s linear infinite",
		"-moz-animation":"$spin 20s linear infinite",
		"animation":"$spin 20s linear infinite",
	},
	"@keyframes spin": {
		"100%": {
			transform: "rotate(360deg)"
		},
	},
	winContainer: {
		position: "absolute",
		top: "50%",
		transform: "translateY(-50%)",
		zIndex: 10,
		left: 0,
		right: 0,
		margin: "auto",

		"& div": {
			fontSize: "35px",
			color: "white",
			fontWeight: "bold",
			marginBottom: "5px"
		},

		"& img": {
			width: "35%"
		}
	},
	bottomText:{
		fontSize: "19px",
		marginBottom: "20px",
		color: "#114c81"
	},
	spinButton: {
		color: "white",
		width: "75%",
		height: "45px"
	},
	disabledSpinButton: {
		backgroundColor: "#54728e !important",
		color: "white !important",
	},
	"@media (max-width: 450px)":{
		modal:{
			"min-width": "95%",
		},
		modalBody:{
			padding: "18px 32px 24px",
			width: "initial",
		},
	}
}));

const WheelModal = props => {
	const { classes,
		removeModalWindow,
		modal,
		addToast,
		countDownText,
		isSpinning,
		canSpin,
		angle,
		hasStoppedSpinning,
		winAmount,
		spinWheel } = props;

	const onOffWheelClick = () => canSpin ? null : removeModalWindow();

	return (
		<Modal
			className={[classes.modal].join(" ")}
			onClose={() => removeModalWindow()}
			open={true}
		>
			<Grow in={true}>
				<div>
					<img className={classes.closeButton} src={getTranslation("image_modal_close_button")} onClick={() => removeModalWindow()}/>
					<div className={`${classes.modalBody} ${classes.defaultBody}`}>
						<div className={classes.header}>{getTranslation("modal_wheel_header")}</div>
						<img
							className={classes.pointerImage}
							src={hasStoppedSpinning ? pointerOffImage : pointerOnImage}/>
						<div
							className={classes.wheelContainer}>
							{(hasStoppedSpinning || (!canSpin && !isSpinning)) &&
							<img
								className={classes.wheelOffImage}
								src={wheelOffImage}
								onClick={onOffWheelClick}/>
							}
							<img
								style={{transform: `rotate(${angle}deg)`}}
								onClick={spinWheel}
								src={wheelImage}/>

							{(hasStoppedSpinning && winAmount) &&
							<div className={classes.winContainer} onClick={onOffWheelClick}>
								<div>
									{
										winAmount === 1 ?
											getTranslation("modal_wheel_win_text_singular") :
											getTranslation("modal_wheel_win_text_plural", [winAmount])
									}
								</div>
								<img
									src={bulbImage}
								/>
							</div>
							}
						</div>

						<div className={classes.bottomText}>
							{
								(hasStoppedSpinning || (!canSpin && !isSpinning)) ?
									getTranslation("modal_bottom_text_cannot_spin") :
									getTranslation("modal_bottom_text_can_spin")
							}
						</div>

						{ !hasStoppedSpinning &&
						<Button
							disabled={isSpinning || hasStoppedSpinning || !canSpin}
							variant="contained"
							color="primary"
							classes={{disabled: classes.disabledSpinButton, root: classes.spinButton}}
							onClick={spinWheel}
						>
							{ (isSpinning || canSpin || !countDownText) ? modal.spinButtonText : countDownText }
						</Button>
						}

						{ hasStoppedSpinning &&
						<Button
							variant="contained"
							color="primary"
							className={`${classes.spinButton}`}
							onClick={() => removeModalWindow()}
						>
							{modal.claimButtonText}
						</Button>}


					</div>
				</div>
			</Grow>
		</Modal>
	)
}

WheelModal.propTypes = {
	hasStoppedSpinning: PropTypes.bool.isRequired,
	angle: PropTypes.number.isRequired,
	serverTimestampOffset: PropTypes.number,
	winAmount: PropTypes.number,

	classes: PropTypes.shape({
	}).isRequired,

	spinWheel: PropTypes.func.isRequired,
};


export default withStyles(styles)(WheelModal);
